export default __webpack_public_path__ + "static/media/i-no-unwrap.2f98f05a.svg";